import { render, staticRenderFns } from "./EditionMinimumSalary.vue?vue&type=template&id=51b9adf4&scoped=true"
import script from "./EditionMinimumSalary.vue?vue&type=script&lang=js"
export * from "./EditionMinimumSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b9adf4",
  null
  
)

export default component.exports